export const TRIAL_PROMO_CODE = 'X-M-FREE14D';


// WEBPACK FOOTER //
// ./src/views/membership/constants.js